<template>
	<div class="c-footer--padding-right-section-side-gutter c-footer--margin-top-section-gutter">
		<a v-if="column.BaseViewModel.ColumnImage" :href="`tel:${column.BaseViewModel.ColumnImagePhone}`"
			target="_blank" class="c-footer__phone-law-link">
			<img :src="column.BaseViewModel.ColumnImage" :alt="column.BaseViewModel.ColumnImageAltText ?? ''"
				class="c-footer__phone-law-link-logo">
		</a>
		<article v-if="column.BaseViewModel.IsTextOnly" class="c-footer__richtext">
			{{ column.BaseViewModel.ColumnText }}
		</article>
		<ul v-else class="c-footer__list">
			<slot></slot>
		</ul>
	</div>
</template>
<script setup lang="ts">
import type { GlobalFooterColumn } from './GlobalFooter.types';

type GlobalFooterColumnProps = {
	column: GlobalFooterColumn,
}

defineProps<GlobalFooterColumnProps>();
</script>
